import { ApiErrorMessageWithTrans } from '@components/Error/ApiErrorMessageWithTrans';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { NoddiCircularLoaderWithTrans } from '@components/Loading/NoddiCircularLoaderWithTrans';
import { t } from '@lingui/core/macro';
import { customerRoutes } from 'noddi-util';
import { Navigate } from 'react-router-dom';
import { useCustomerGroupRole } from '../../../hooks/useCustomerGroupRole';
import { FleetView } from './FleetView';

export const FleetPage = () => {
  const role = useCustomerGroupRole();

  // A plain member has no Fleet in the menu; their cars and bookings are on Home.
  if (role.kind === 'organizationMember') {
    return <Navigate to={customerRoutes.homepage.getPath()} replace />;
  }

  return (
    <ContentWrapperCustomerApp hideBackButton width='wide' title={t`Fleet`}>
      {role.kind === 'loading' ? (
        <NoddiCircularLoaderWithTrans />
      ) : role.kind === 'error' ? (
        <ApiErrorMessageWithTrans error={role.error} />
      ) : (
        <FleetView />
      )}
    </ContentWrapperCustomerApp>
  );
};
